

/**
 * Takes an array and returns a new array where one element is replaced.
 */
export function replaceInArray<T>(
    arr: T[],
    selector: (t: T) => boolean,
    replacer: (t: T) => T
): T[] | undefined {
    arr = arr.slice();
    const index = arr.findIndex(selector);
    if (index < 0)
        return undefined;
    const original = arr[index];
    const replacement = replacer(original);
    arr[index] = replacement;
    return arr;
}
